import MediaBox from './MediaBox';

export default MediaBox;
